(function () {
  if (window.pdpAccordionReady) return;
  window.pdpAccordionReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (event) {
    const summary = event.target.closest('.pdp-info__summary');
    if (!summary) return;

    const details = summary.closest('details.pdp-info');
    if (!details || summary.parentElement !== details) return;

    const panel = details.querySelector(':scope > .pdp-info__panel');
    if (!panel) return;

    if (reduceMotion.matches) {
      panel.style.height = '';
      return;
    }

    event.preventDefault();
    if (details.dataset.animating === 'true') return;

    if (details.open) {
      collapse(details, panel);
    } else {
      expand(details, panel);
    }
  });

  function expand(details, panel) {
    details.dataset.animating = 'true';
    details.open = true;

    const target = panel.scrollHeight;
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = target + 'px';

    whenHeightEnds(panel, function () {
      panel.style.height = 'auto';
      details.dataset.animating = 'false';
    });
  }

  function collapse(details, panel) {
    details.dataset.animating = 'true';
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.height = '0px';

    whenHeightEnds(panel, function () {
      details.open = false;
      details.dataset.animating = 'false';
    });
  }

  function whenHeightEnds(panel, callback) {
    let finished = false;

    function finish(event) {
      if (finished) return;
      if (event && (event.target !== panel || event.propertyName !== 'height')) return;
      finished = true;
      panel.removeEventListener('transitionend', finish);
      callback();
    }

    panel.addEventListener('transitionend', finish);
    window.setTimeout(finish, 450);
  }
})();
